import React from 'react';
import { useContextFactory } from '../../../helpers/useContextFactory';

export const StudentListContext = React.createContext();
export const useStudentListContext = useContextFactory(
  'StudentListContext',
  StudentListContext,
);
